"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommonAnalytics = void 0;
var _issuesBaseProps = require("../issuesBaseProps");
var _platform = _interopRequireDefault(require("platform"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _alloyHooks = require("../../hooks/alloyHooks");
var _alloyProvider = require("@adsk/alloy-provider");
var _projectMembersHooks = require("../../hooks/projectMembersHooks");
var _getUserRole = require("../utils/getUserRole");
var _getUserPermission = require("../utils/getUserPermission");
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 /* Package.json is outside of our Typescript rootDir therefore, we use require, instead of import.
 /* If we change the rootDir to include this file, it would change the output of es folder and break our consumers
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const accIssuesPackage = require("../../../../../package.json");
const useCommonAnalytics = () => {
  const {
    user: currentUser
  } = (0, _alloyHooks.useUser)();
  const {
    data: users,
    loading
  } = (0, _alloyProvider.useUsers)();
  const roles = (0, _projectMembersHooks.useRolesEntitiesMapById)();
  (0, _react.useEffect)(() => {
    var _platform$os, _platform$os2;
    if (loading || (0, _isEmpty.default)(roles)) {
      return;
    }
    const fullUser = users.find(tempUser => tempUser.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
    if (!fullUser) {
      return;
    }
    const userRoleName = (0, _getUserRole.getUserRole)(fullUser, roles);
    const userPermission = (0, _getUserPermission.getUserPermission)(fullUser);
    (0, _issuesBaseProps.setIssueAnalyticsBaseProps)({
      user_id: fullUser.id,
      user_company: fullUser.companyName || "",
      user_role: userRoleName,
      user_permission: userPermission,
      device_family: (_platform$os = _platform.default.os) === null || _platform$os === void 0 ? void 0 : _platform$os.family,
      device_type: (_platform$os2 = _platform.default.os) === null || _platform$os2 === void 0 ? void 0 : _platform$os2.toString(),
      issues_frontend_version: accIssuesPackage.version
    });
  }, [loading, users, currentUser, roles]);
};
exports.useCommonAnalytics = useCommonAnalytics;
//# sourceMappingURL=useCommonAnalytics.js.map